import { z } from 'zod'

import type { CortesInput } from '@/api/endpoints/factories'

/** Schema, defaults e corpo do ``POST /factories/cortes/start``, fora do
 * componente para serem testados sem DOM. */
export const cortesSchema = z
  .object({
    source_type: z.enum(['url', 'upload']),
    source_url: z.string().trim().optional(),
    source_path: z.string().trim().optional(),
    language: z.enum(['pt-br', 'en']),
    max_clips: z.number().int().min(1).max(20),
    min_clip_seconds: z.number().int().min(5).max(180),
    max_clip_seconds: z.number().int().min(10).max(300),
    reframe_mode: z.enum(['center', 'face_track', 'smart']),
    subtitle_style: z.string().min(1),
    subtitle_active_color: z.string().optional(),
    custom_prompt: z.string().trim().max(600).optional(),
    // The whole of the v1 copyright control (card #27): the operator must
    // assert the source is authorized before the pipeline will run.
    // Escape do guard de duplicata do backend: sem isso, um 409 barra a
    // segunda run sobre a mesma fonte e não há como insistir pela UI.
    force: z.boolean(),
    llm_provider: z.enum(['auto', 'cloud', 'local']).optional(),
  })
  .refine((v) => (v.source_type === 'url' ? !!v.source_url : true), {
    path: ['source_url'],
    message: 'Cole a URL do vídeo (podcast).',
  })
  .refine((v) => (v.source_type === 'upload' ? !!v.source_path : true), {
    path: ['source_path'],
    message: 'Informe o caminho do arquivo enviado pelo ClipCreator.',
  })
  .refine((v) => v.max_clip_seconds >= v.min_clip_seconds, {
    path: ['max_clip_seconds'],
    message: 'A duração máxima deve ser ≥ a mínima.',
  })

export type CortesFormValues = z.infer<typeof cortesSchema>

export const FORM_DEFAULTS: CortesFormValues = {
  source_type: 'url',
  source_url: '',
  source_path: '',
  language: 'pt-br',
  max_clips: 5,
  min_clip_seconds: 20,
  max_clip_seconds: 90,
  reframe_mode: 'smart',
  subtitle_style: 'solid',
  custom_prompt: '',
  force: false,
  llm_provider: 'auto',
}

export function toCortesInput(values: CortesFormValues, channel: string): CortesInput {
  return {
    channel: channel || null,
    source_url: values.source_type === 'url' ? (values.source_url ?? '').trim() : '',
    source_path: values.source_type === 'upload' ? (values.source_path ?? '').trim() : '',
    language: values.language,
    max_clips: values.max_clips,
    min_clip_seconds: values.min_clip_seconds,
    max_clip_seconds: values.max_clip_seconds,
    reframe_mode: values.reframe_mode,
    subtitle_style: values.subtitle_style,
    ...(values.subtitle_style === 'karaoke' && values.subtitle_active_color
      ? { subtitle_active_color: values.subtitle_active_color }
      : {}),
    custom_prompt: (values.custom_prompt ?? '').trim(),
    force: values.force,
    llm_provider: values.llm_provider ?? 'auto',
  }
}
